<h2 style="margin: 10px;">{{title}}</h2>
<mat-dialog-content class="mat-typography">
  <span style="font-size: 18px; font-weight: bold;">{{content}}</span>
</mat-dialog-content>

<!-- Confirm added vessels-->
<div mat-dialog-actions>
  @if (!singleButton) {
    <button mat-raised-button
            type="button"
            style="background-color: #003f61; color: white;"
            (click)="dialogRef.close(false)">
      {{cancelButton}}
    </button>
  }
  <span style="flex: 1 1 auto;"></span>
  <button mat-raised-button
          type="submit"
          style="background-color: coral; color: white;"
          align="end"
          (click)="confirmClck()">
    {{confirmButton}}
  </button>
</div>
